import HTTPHandler, { formatResponse } from 'lib/api/HTTPHandler'
import { FB_API_URL } from 'lib/api/env'
import { createError } from 'lib/api/serverError'

class FinbrokerService {
  static getCreditRequests = async saleGlobalId => {
    try {
      const res = await HTTPHandler.get(
        FB_API_URL + `/finbroker/credit_request/sale_global/${saleGlobalId}`
      )
      return formatResponse(res)
    } catch (e) {
      return createError(e)
    }
  }
}

export default FinbrokerService
